import React from "react";

export function Button({
  children,
  className = "",
  ...props
}: React.ButtonHTMLAttributes<HTMLButtonElement>) {
  return (
    <button
      className={`px-4 py-2 rounded-md bg-green-600 text-white hover:bg-green-700 ${className}`}
      {...props}
    >
      {children}
    </button>
  );
}
